import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { LearningPathsList } from '../app/components/learning-path/learning-paths-list';
import { ProtectedRoute } from '@org/ui';

export const Route = createFileRoute('/learning-paths')({
  component: LearningPathsRoute,
});

function LearningPathsRoute() {
  const navigate = useNavigate({ from: '/learning-paths' });

  return (
    <ProtectedRoute requiredPermissions={['admin:all', 'journeys:*']}>
      <div className="space-y-6">
        <LearningPathsList
          onCreatePath={() => navigate({ to: '/learning-paths/new' })}
          onEditPath={(path) =>
            navigate({ to: '/learning-paths/$pathId', params: { pathId: path.pathId } })
          }
        />
        <Outlet />
      </div>
    </ProtectedRoute>
  );
}
